<div class="view-file-dialog">
  <div class="dialog-header">
    <span class="dialog-title">File Preview</span>
    <button
      class="close-button"
      type="button"
      (click)="close()"
      aria-label="Close"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18M6 6L18 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
  <div class="dialog-content">
    <ng-container *ngIf="safePreviewUrl; else errorBlock">
      <iframe
        [src]="safePreviewUrl"
        width="100%"
        height="550px"
        style="border: none"
      ></iframe>
    </ng-container>
    <ng-template #errorBlock>
      <div class="error-msg">Unable to load file.</div>
    </ng-template>
  </div>

  <div class="form-footer">
    <ng-container>
      <app-button-group
        [label]="'Cancel'"
        [buttonType]="'Secondary'"
        [buttonUseCase]="'Cancel'"
        [cssClass]="'cancel-btn'"
        (onEmit)="close()"
      ></app-button-group>
      <app-button-group
        [label]="'Download'"
        [icon]="'download'"
        [buttonType]="'Secondary'"
        [cssClass]="'bordered-bg'"
        [disabled]="!safePreviewUrl"
        (onEmit)="download()"
      ></app-button-group>
    </ng-container>
  </div>
</div>
